module.exports = __webpack_public_path__ + "static/img/img3.3e2751c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5/img3.png
// module id = VHNH
// module chunks = 0